import React, { useContext, useEffect, useState } from "react";
import { profileURL, schoolURL, teacherURL } from "../../Hooks/URL";
import useFetch from "../../Hooks/useFetch";
import useDelete from "../../Hooks/useDelete";
import { useParams } from "react-router-dom";
import { userContext } from "../../Contexts/userContext";
import useSave from "../../Hooks/useSave";
import Profile from "../../Templates/Profile/Profile";
import useFetchWhen from "../../Hooks/useFetchWhen";

function ProfilePage() {
  const { contextData, setContextData } = useContext(userContext);
  let { id } = useParams();

  const url = `${contextData?.role == "school" ? schoolURL : teacherURL}/me`;
  const page = "profile";

  const [PassOpen, setPassOpen] = useState(false);

  const [profile, setProfile] = useState({});
  const { data, loading, error } = useFetchWhen(
    contextData?.role == "admin"
      ? `${profileURL}/admin`
      : contextData?.role == "school"
      ? `${profileURL}/school`
      : `${profileURL}/teacher`,
    contextData?.role
  );

  useEffect(() => {
    if (!loading && !error && data) {
      setProfile(data.data);
    }
  }, [data, loading, error]);

  return (
    <Profile
      PassOpen={PassOpen}
      setPassOpen={setPassOpen}
      profile={profile}
      loading={loading}
      role={contextData?.role}
    />
  );
}

export default ProfilePage;
